const MAX_REGIONS_NUMBER = 5 as const;

const ICONS_SIZE = {
  CHEVRON: 16,
  TRASH: 18,
} as const;

export { MAX_REGIONS_NUMBER, ICONS_SIZE };
